import { render, staticRenderFns } from "./SynthesisOfAlum.vue?vue&type=template&id=073c9692&"
import script from "./SynthesisOfAlum.vue?vue&type=script&lang=js&"
export * from "./SynthesisOfAlum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports